import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "bonusomat-quest-accordion__header" }
const _hoisted_2 = ["innerHTML"]

import { onMounted, ref, toRef } from "vue";
import DsAccordionItem from "@sazka/design-system/src/accordion-item/ds-accordion-item.vue";
import { useAccordion } from "@sazka/utils/composables/use-accordion";
import { Theme } from "@sazka/design-system/src/types/theme";
import BonusomatProgress from "../shared/bonusomat-progress.vue";
import DsButton from "@sazka/design-system/src/button/ds-button.vue";
import { BonusomatQuestTask } from "../../models/bonusomat-quest-detail";


export default /*@__PURE__*/_defineComponent({
  __name: 'bonusomat-quest-detail-accordion',
  props: {
    tasks: {},
    defaultOpenTaskIndex: {},
    scrollTaskIntoView: { type: Boolean },
    theme: {}
  },
  emits: ["showTaskGames"],
  setup(__props: any, { emit: __emit }) {

const parentRef = ref<HTMLElement>(null);

const props = __props;

const { init } = useAccordion({
    openOnlyOne: false,
    withScrollIntoView: toRef(() => props.scrollTaskIntoView),
});
const emit = __emit;

const handleOpenModal = (taskToShowGames: BonusomatQuestTask, taskIndex: number) => {
    emit("showTaskGames", taskToShowGames, taskIndex);
};

const accordionItemExpanded = (index: number) => {
    if (document.body.classList.contains("firefox") && index >= props.tasks.length - 2) {
        const parentScrollWrapElem = parentRef.value?.closest(".ds-modal-dialog__content");
        if (parentScrollWrapElem) {
            setTimeout(() => {
                parentScrollWrapElem.scrollTo({
                    top: parentScrollWrapElem.scrollHeight,
                    left: 0,
                    behavior: "smooth",
                });
            }, 400);
        }
    }
};

onMounted(() => {
    const allElements = parentRef.value?.querySelectorAll(".ds-accordion-item");

    init(allElements);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["ds-accordion bonusomat-quest-accordion", { 'is-dark': _ctx.theme === 'dark' }]),
    ref_key: "parentRef",
    ref: parentRef
  }, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.tasks, (item, index) => {
      return (_openBlock(), _createBlock(DsAccordionItem, {
        "default-open": index == _ctx.defaultOpenTaskIndex,
        key: index,
        "item-id": index,
        "header-icon-name": "chevron-down-thin",
        onExpanded: ($event: any) => (accordionItemExpanded(index))
      }, {
        summary: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createVNode(BonusomatProgress, {
              progress: item.progress,
              "is-completed": item.progress === 100,
              "always-visible": "",
              "show-percentage-number": ""
            }, null, 8, ["progress", "is-completed"]),
            _createTextVNode(_toDisplayString(item.title), 1)
          ])
        ]),
        text: _withCtx(() => [
          _createElementVNode("span", {
            innerHTML: item.description
          }, null, 8, _hoisted_2),
          (item.games?.length)
            ? (_openBlock(), _createBlock(DsButton, {
                key: 0,
                theme: "dark",
                type: "interaction",
                size: "sm",
                onClick: ($event: any) => (handleOpenModal(item, index)),
                class: "bonusomat-quest__show-games-btn"
              }, {
                default: _withCtx(() => _cache[0] || (_cache[0] = [
                  _createTextVNode("Zobrazit hry")
                ])),
                _: 2,
                __: [0]
              }, 1032, ["onClick"]))
            : _createCommentVNode("", true)
        ]),
        _: 2
      }, 1032, ["default-open", "item-id", "onExpanded"]))
    }), 128))
  ], 2))
}
}

})